import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL, ICombineHsaRequestDto } from '@/dtos';

interface Params {
  employeeId: string;
  accountId: string;
  payload: ICombineHsaRequestDto;
}

export const useCombineHSASubmitQuery = () => {
  const { mutateAsync, isPending } = useMutation(({ employeeId, accountId, payload }: Params) =>
    api.post<void>(
      API_URL.EMPLOYEES_ACCOUNT_COMBINE_WITH_HSA_BY_EMPLOYEE_ID_ACCOUNT_ID(employeeId, accountId),
      payload
    )
  );

  return {
    combineHSASubmit: mutateAsync,
    isLoading: isPending,
  };
};
